module.exports = __webpack_public_path__ + "static/images/icon-qq-disabled.dec72cc.png";